// @flow

import React from 'react';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from 'react-google-maps';

import { compose, withProps } from 'recompose';
import { sanitizeUrl } from '../../utils/sanitize';

const mapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
const mapsBaseUrl = 'https://maps.googleapis.com/maps/api/js';
const mapsQuery = `?key=${encodeURIComponent(mapsApiKey)}&v=3.exp&libraries=geometry,drawing,places`;
const safeGoogleMapUrl = sanitizeUrl(`${mapsBaseUrl}${mapsQuery}`) || '';

const ContactMap = compose(
  withProps({
    googleMapURL: safeGoogleMapUrl,
    loadingElement: <div style={{ height: `500px`, width: '100%' }} />,
    containerElement: <div className="google-location" />,
    mapElement: <div style={{ height: `500px`, width: '100%' }} />
  }),
  withScriptjs,
  withGoogleMap
)(props => (
  <GoogleMap
    defaultZoom={17}
    defaultCenter={{ lat: 47.9233294, lng: 25.6734975 }}
  >
    <Marker position={{ lat: 47.9233294, lng: 25.6734975 }} />
  </GoogleMap>
));

export default ContactMap;